import CheckBoxSelection from 'assets/images/icons/CheckBoxSelection.svg'
import checkboxSelected from 'assets/images/icons/checkboxSelected.svg'
import styled from 'styled-components'

const CustomCheckbox = ({ checked, onChange }: { checked: boolean; onChange: () => void }) => {
  return (
    <CheckboxWrapper onClick={onChange}>
      <img src={checked ? CheckBoxSelection : checkboxSelected} alt={checked ? 'Checked' : 'Unchecked'} />
    </CheckboxWrapper>
  )
}

const CheckboxWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
  }
`

export default CustomCheckbox
